import { render, staticRenderFns } from "./noticias.vue?vue&type=template&id=8880eca4&scoped=true"
import script from "./noticias.vue?vue&type=script&lang=js"
export * from "./noticias.vue?vue&type=script&lang=js"
import style0 from "./noticias.vue?vue&type=style&index=0&id=8880eca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8880eca4",
  null
  
)

export default component.exports